import _ from "lodash";

export type Status =
  | "future"
  | "in_trial"
  | "active"
  | "non_renewing"
  | "paused"
  | "cancelled";

export const statuses: Status[] = [
  "future",
  "in_trial",
  "active",
  "non_renewing",
  "paused",
  "cancelled",
];

export const selectStatuses = statuses.map((status) => {
  return { value: status, label: status.replaceAll("_", " ").toUpperCase() };
});

export const colorsByStatus: Record<Status, string> = {
  future: "cyan",
  active: "green",
  cancelled: "yellow",
  non_renewing: "blue",
  paused: "orange",
  in_trial: "purple",
};
